import { Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import Finish from "../images/finish.svg";
import { pages } from "../pages/pages";
import { ButtonContainer, Container, ImageContainer, StyledImage } from "./Summary.sc";

const SimpleSummary: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleBackToHome = () => {
        navigate(pages.home);
    };

    const completedExercises = searchParams.get("exercises")?.split(",");

    return (
        <Container>
            <Typography variant="h4" color="primary" textAlign="center">
                {t("well_done")}
            </Typography>
            <ImageContainer>
                <StyledImage src={Finish} />
            </ImageContainer>
            <Typography textAlign="center" color="primary" fontWeight="700">
                {t("exercises")}:
            </Typography>
            {completedExercises && (
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", listStyle: "none", padding: 0 }}>
                    {completedExercises.map((exercise) => (
                        <li key={exercise}>
                            <Typography textAlign="center">{exercise} </Typography>
                        </li>
                    ))}
                </ul>
            )}

            <ButtonContainer>
                <Button variant="contained" color="primary" onClick={handleBackToHome}>
                    {t("back_to_home")}
                </Button>
            </ButtonContainer>
        </Container>
    );
};

export default SimpleSummary;
